import { SUB_LOCATION } from '../../../MediaProductCreate/MediaProductCreateForm/fields'
import { LOCATION } from '../../../fields'

export const formatLocationTabsToBE = values => {
  return {
    [LOCATION]: values[LOCATION] ? values[LOCATION] : null,
    [SUB_LOCATION]: values[SUB_LOCATION] ? values[SUB_LOCATION] : null
  }
}
